import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createMachinePart } from '@/apis/machinePart'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateMachinePartsRequest } from '@/types/apis/machineParts/CreateMachinePartRequest'
import { CreateMachinePartResponse } from '@/types/apis/machineParts/CreateMachinePartResponse'

export const useCreateMachinePart = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateMachinePartResponse>()

  const create = useCallback(
    async (request: CreateMachinePartsRequest) => {
      try {
        setLoading(true)
        const res = await createMachinePart(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        const path = routes.machineParts.path.replace(':id', request.washingMachineId.toString())
        navigate(path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createMachinePart: create,
    response,
  }
}
